/**
 * CMS locale constants (match Prismic locales).
 * UI codes (en, es, fr...) map to these values via `UI_TO_CMS_MAP`.
 */

export const LANGUAGES = {
    // CMS/Prismic locale codes
    ENGLISH: 'en-au',
    SPANISH: 'es-es',
    FRENCH: 'fr-fr',
    GERMAN: 'de-de',
    PORTUGUESE_BRAZILIAN: 'pt-br',
    CHINESE_SIMPLIFIED: 'zh-cn',
    RUSSIAN: 'ru-ru',
    POLISH: 'pl-pl',
    JAPANESE: 'ja-jp',
    DUTCH: 'nl-nl',
    ITALIAN: 'it-it',
    KOREAN: 'ko-kr',
} as const;

// Map the shorter UI language codes used in settings to the exact CMS locale
// strings required by Prismic. Keep this mapping explicit so it's obvious how
// UI choices translate into CMS queries.
export const UI_TO_CMS_MAP = {
    en: LANGUAGES.ENGLISH,
    es: LANGUAGES.SPANISH,
    fr: LANGUAGES.FRENCH,
    de: LANGUAGES.GERMAN,
    pt: LANGUAGES.PORTUGUESE_BRAZILIAN,
    zh: LANGUAGES.CHINESE_SIMPLIFIED,
    ru: LANGUAGES.RUSSIAN,
    pl: LANGUAGES.POLISH,
    ja: LANGUAGES.JAPANESE,
    nl: LANGUAGES.DUTCH,
    it: LANGUAGES.ITALIAN,
    ko: LANGUAGES.KOREAN,
} as const;

export const DEFAULT_LANGUAGE = LANGUAGES.ENGLISH;
export const SUPPORTED_LANGUAGES = Object.values(LANGUAGES);

export type SupportedLanguage = (typeof LANGUAGES)[keyof typeof LANGUAGES];
